import InputIcon from "../InputIcon/InputIcon";
import InputDefault from "../InputDefault/InputDefault";
const  TextSearchCard= (props) => {
    return (
        <InputIcon {...props}></InputIcon>
    );
}
 
export default TextSearchCard;